export type StripePlanMapping = {
  plan_code: "unlimited";
  credits: number;
};

// Default monthly lead allowance granted on subscription / renewal. The plan
// is marketed as Unlimited; this cap exists only as an anti-spam / anti-abuse
// floor and is raised on request via support (an admin tops up the user's
// add-on credits). The number is also surfaced to users in the cap-reached
// message — keep them in sync.
export const INITIAL_MONTHLY_LEAD_CAP = 15_000;

// Free tier: contacts a signed-in user with NO subscription may deliver per
// calendar month (UTC), metered against the same credit_ledger debit rows as
// the paid plan. Single source for the server clamp and the UI copy.
export const FREE_MONTHLY_CONTACT_CAP = 25;

// The display name and price shown on the marketing/checkout pages are
// controlled in config/counties/default.ts and per-country JSON overrides.
export const STRIPE_PRICE_IDS = {
  subscription: {
    unlimited: "price_1SpypCJatWzAj2D4sqyPT3DS",
  },
} as const;

export const STRIPE_PLAN_MAP: Record<string, StripePlanMapping> = {
  [STRIPE_PRICE_IDS.subscription.unlimited]: {
    plan_code: "unlimited",
    credits: INITIAL_MONTHLY_LEAD_CAP,
  },
};

// Prices a NEW checkout session may be created for.
export const PURCHASABLE_PRICE_IDS: ReadonlySet<string> = new Set([
  STRIPE_PRICE_IDS.subscription.unlimited,
]);

export function isPurchasablePrice(priceId: string): boolean {
  return PURCHASABLE_PRICE_IDS.has(priceId);
}

// Fail-closed: returns a mapping only for a known subscription price. Unknown
// prices return null so the webhook grants nothing.
export function getSubscriptionMapping(
  priceId: string,
): StripePlanMapping | null {
  return STRIPE_PLAN_MAP[priceId] ?? null;
}
